import React from 'react';
import EditRegister from '../../../components/editregister/EditRegister';

export const TransportEditProfile = () => {
  return <EditRegister />;
};
